import {
  Checkbox as AntdCheckbox,
  CheckboxProps as AntdCheckboxProps,
  CheckboxOptionType as AntdCheckboxOptionType,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface CheckboxProps extends AntdCheckboxProps {}
export interface CheckboxOptionType extends AntdCheckboxOptionType {}

export const checkboxPrefixCls = `${CMP_PREFIX}-checkbox`;

export const Checkbox = ({ ...props }: CheckboxProps) => {
  return <AntdCheckbox {...props} />;
};

export const CheckboxGroup = AntdCheckbox.Group;
